const translations = {
  app: {
    default: 'Standaard',
    company: 'Quicq',
    title: 'Dashboard',
    searchBar: {
      search: {
        label: 'Zoeken',
        placeholder: 'Zoeken',
      },
    },
    switchedTenant: {
      title: 'Organisatie gewisseld',
      message:
        'Je bent van organisatie gewisseld in een ander venster. Klik hieronder op de "Ok" knop, om in het huidige venster te wisselen naar deze organisatie.',
      actions: {
        ok: 'Ok',
      },
    },
    dock: {
      iam: 'Dashboard',
      spl: 'Spooler',
      cnt: 'Files',
      mes: 'Berichten',
      dashboard: 'Afosto',
      notifications: 'Notificaties',
      fulfilment: 'Fulfilment',
      picker: 'Picker',
      spooler: 'Spooler',
      products: 'Producten',
      user: 'Gebruiker',
      wms: 'WMS',
      rel: 'Contacten',
      order: 'Orders',
      messaging: 'Berichten',
      userMenu: {
        signOut: 'Uitloggen',
        selectTenant: 'Selecteer een organisatie',
        searchTenants: {
          placeholder: 'Zoeken naar organisaties',
        },
        addNewTenant: {
          title: 'Nieuwe organisatie toevoegen',
          subtitle: 'Vraag toegang aan voor een nieuwe organisatie',
        },
        emptyTenants: 'Geen organisaties gevonden',
        subtenantForm: {
          description:
            'Voer het e-mailadres in van de organisatie waar je toegang toe wilt verkrijgen.',
          fields: {
            signee: 'E-mailadres',
          },
          actions: {
            cancel: 'Annuleren',
            sent: 'Verstuur verzoek',
          },
        },
        switchTenant: 'Switch organisatie',
      },
      notificationsMenu: {
        none: 'Geen notificaties',
        all: 'Alle notificaties',
      },
    },
    navigation: {
      main: {
        dashboard: 'Dashboard',
        proxies: 'Proxies',
        documentation: 'Documentatie',
      },
    },
  },
  confirmCancelFormDialog: {
    title: 'Venster verlaten',
    description:
      'Weet je zeker dat je het venster wilt verlaten? Wijzigingen zullen niet worden opgeslagen.',
    buttons: {
      cancel: 'Annuleren',
      leaveWindow: 'Venster verlaten',
    },
  },
  dateOptions: {
    today: 'Vandaag',
    relativeNow: 'Relatief vanaf nu',
    relative: 'Relatief',
    date: 'Datum',
  },
  betweenOptions: {
    from: 'Van',
    to: 'Tot en met',
  },
  pages: {
    dashboard: {
      title: 'Dashboard',
      sections: {
        trafficPerDay: {
          title: 'Verkeer per dag',
        },
        trafficThisMonth: {
          title: 'Verkeer deze maand',
        },
        transformationsThisMonth: {
          title: 'Transformaties deze maand',
        },
        upcomingInvoice: {
          title: 'Aanstaande factuur',
        },
      },
      noProxies: {
        title: 'Maak je eerste Quicq proxy',
        description:
          'Je hebt nog geen Quicq proxy aangemaakt. Ga naar de proxies pagina om je eerste proxy aan te maken.',
        actions: {
          proxiesPage: 'Proxies pagina',
        },
      },
    },
    proxy: {
      create: {
        title: 'Nieuwe proxy',
      },
      edit: {
        title: 'Proxy bewerken',
      },
      feedback: {
        proxyCreated: 'Proxy aangemaakt',
        proxyNotCreated: 'Proxy kon niet worden aangemaakt',
        proxyUpdated: 'Proxy bijgewerkt',
        proxyNotUpdated: 'Proxy kon niet worden bijgewerkt',
      },
    },
  },
  proxyForm: {
    sections: {
      cache: 'Cache',
      auth: 'Authenticatie',
      oauth: 'oAuth',
      routes: 'Routes',
    },
  },
  viewSelection: {
    title: 'Opgeslagen views',
    actions: {
      setAsDefault: 'Instellen als standaard',
    },
    confirmDeleteView: {
      title: 'View verwijderen',
      description: 'Weet je zeker dat je deze view wilt verwijderen?',
      buttons: {
        cancel: 'Annuleren',
        delete: 'Verwijderen',
      },
    },
  },
  filterSelection: {
    title: 'Filters',
    resetButton: 'Reset filters',
    rowCount: '{count} van {total}',
    filterSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newFilterHeader: 'Filter toevoegen',
    },
  },
  dataGrid: {
    defaultView: {
      name: 'Standaard',
      description: 'Standaard weergave',
    },
    columns: {
      proxies: {
        key: 'Sleutel',
        origin: 'URL',
      },
    },
    sortSelection: {
      title: 'Sortering',
      resetButton: 'Reset sortering',
    },
    sortDirections: {
      asc: 'Oplopend',
      desc: 'Aflopend',
    },
    sortOptionSelectionItem: {
      cancelButton: 'Annuleren',
      saveButton: 'Opslaan',
      createButton: 'Toevoegen',
      newSortOptionHeader: 'Sortering toevoegen',
    },
    filters: {
      label: {
        between: '{name} tussen {first} en {second}',
      },
    },
    filterOperators: {
      is: 'Is gelijk aan',
      in: 'Bevat',
      missing: 'Bevat geen waarde',
      not_in: 'Bevat niet',
      gt: 'Is groter dan',
      gte: 'Is groter dan of gelijk aan',
      lt: 'Is kleiner dan',
      lte: 'Is kleiner dan of gelijk aan',
      between: 'Is tussen',
    },
    filterValues: {
      noValue: 'geen waarde',
    },
    filterConjunctions: {
      and: 'en',
    },
    columnSelection: {
      title: 'Kolommen',
      searchField: {
        placeholder: 'Zoeken ...',
      },
      addColumn: {
        label: 'Kolom toevoegen',
      },
      availableColumns: {
        label: 'Beschikbare kolommen',
      },
      selectedColumns: {
        label: 'Geselecteerde kolommen',
      },
      resetButton: 'Reset kolommen',
    },
    addColumn: {
      title: 'Kolom toevoegen',
      inputs: {
        name: {
          label: 'Naam',
        },
        formula: {
          label: 'Formule',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
    gridActions: {
      view: {
        title: 'Views',
        settings: 'Instellingen',
        views: 'Views',
        showMore: 'Toon meer',
        saveAs: 'Opslaan als',
        manageSettings: 'Beheren',
        defaultSettings: 'Terugzetten naar standaard',
      },
      columnSelection: {
        title: 'Kolommen',
      },
      sorting: {
        title: 'Sortering',
      },
      dataExport: {
        title: 'Exporteren',
        currentColumns: 'Huidige kolommen',
        allColumns: 'Alle kolommen',
        csv: 'CSV',
        excel: 'Excel',
        pdf: 'PDF',
      },
      dataImport: {
        title: 'Importeren',
      },
      copyGridUrl: {
        title: 'URL kopiëren',
        tooltip: 'Url gekopieerd',
      },
    },
    search: {
      placeholder: 'Zoek',
      exactMatch: 'Exacte match: {state}',
    },
    selection: {
      button: {
        all: 'Alles',
      },
      selected: '{count} van {total} geselecteerd',
    },
    pagination: {
      currentPageLabel: 'pagina {page}',
      previousPageLabel: 'Vorige pagina',
      nextPageLabel: 'Volgende pagina',
      displayedRows: '{from} - {to} van {count}',
      rowsPerPage: 'Rijen per pagina:',
      many: 'veel',
    },
    exportSelection: {
      title: 'Exporteren',
    },
    views: {
      label: {
        system: 'Systeem',
        private: 'Privé',
      },
    },
    viewSelectionMenu: {
      activeView: {
        label: 'Weergave',
      },
    },
    saveView: {
      title: 'Weergave opslaan als',
      showViewInformation: {
        button: {
          show: 'Toon informatie',
          hide: 'Verberg informatie',
        },
        columns: 'Kolommen',
        filters: 'Filters',
        sorting: 'Sortering',
        itemsPerPage: 'Rijen per pagina',
      },
      inputs: {
        name: {
          label: 'Naam',
          helperText: 'Gebruik een bestaande naam om de weergave te overschrijven',
        },
        saveViewForTenant: {
          label: 'Beschikbaar voor elke gebruiker',
        },
      },
      buttons: {
        cancel: 'Annuleren',
        save: 'Opslaan',
      },
    },
  },
  formFields: {
    searchUser: {
      placeholder: 'Zoek een gebruiker',
    },
  },
  applicationUpdateNotification: {
    updateAvailableMessage: 'Nieuwe versie van de app beschikbaar',
    updateButton: {
      label: 'Bijwerken',
    },
  },
  relativeDate: {
    properties: {
      quantity: 'Aantal',
      dayOfWeek: 'Dag van de week',
      dayOfMonth: 'Dag van de maand',
      type: 'Type',
      time: 'Tijd',
    },
    dateTypeOptions: {
      minutes: 'Minuten',
      hours: 'Uren',
      days: 'Dagen',
      weeks: 'Weken',
      months: 'Maanden',
    },
  },
  actions: {
    add: 'Toevoegen',
    remove: 'Verwijderen',
    back: 'Terug',
    continue: 'Verder',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    filter: 'Filter',
    goToList: 'Bekijk overzicht',
    save: 'Opslaan',
    edit: 'Wijzigen',
    configure: 'Instellen',
    disable: 'Uitschakelen',
    activate: 'Activeren',
    retry: 'Opnieuw proberen',
    close: 'Sluiten',
    view: 'Bekijken',
  },
  filter: {
    selectAnOption: 'Selecteer een optie...',
    equals: 'Is gelijk aan',
    chipContent: {
      equals: '{filter} is {option}',
    },
  },
  pagination: {
    pageNumber: 'Pagina {i}',
  },
  formActions: {
    cancel: 'Annuleren',
    save: 'Opslaan',
    next: 'Volgende',
    verify: 'Verifiëren',
    finish: 'Afronden',
  },
  properties: {
    from: 'Van',
    until: 'Tot en met',
    key: 'Sleutel',
    originUrl: 'URL',
    ignoreOriginCache: 'Cache negeren',
    addCanonical: "Canonical URL's toevoegen",
    watermarkUrl: 'URL watermerk afbeelding',
    total: 'Totaal',
    subtotal: 'Subtotaal',
    trialPeriod: 'Proefperiode',
    path: 'Pad',
    uri: 'URI',
    isBucket: 'Bucket',
    isAsOrigin: 'Als origineel',
    isPublic: 'Publiek',
    age: 'Leeftijd',
    isRequired: 'Verplicht',
    secret: 'Geheim',
    scope: 'scope',
    issuer: 'Uitgever',
    clientId: 'Client',
    authorizeUrl: 'Authenticatie URL',
    returnUrlKey: 'Return URL sleutel',
  },
  errors: {
    validation: {
      empty: '{target} mag niet leeg zijn',
      urlHasProtocol: "{target} dient te beginnen met 'https://' of 'http://'",
      validEmailFormat: 'Vul een geldig e-mail adres in',
      required: '{target} mag niet leeg zijn',
      validEmail: 'Vul een geldig e-mail adres in',
      url: '{target} dient een geldige URL te zijn',
      integer: '{target} moet een geheel getal zijn',
      minLength: '{target} moet minstens {min} karakters lang zijn',
      maxLength: '{target} mag maximaal {max} karakters lang zijn',
      minNumber: '{target} moet minimaal {min} zijn',
      maxNumber: '{target} moet kleiner zijn of gelijk aan {max}',
      minItems: '{target} moet minimaal {min} items bevatten',
      maxItems: '{target} mag maximaal {max} items bevatten',
      atLeastOneNormalCharacter: '{target} mag niet alleen speciale tekens bevatten',
    },
  },
  components: {
    autocomplete: {
      clearText: 'Legen',
      loadingText: 'Laden...',
      noOptionsText: 'Geen opties',
      openText: 'Open',
    },
  },
  sessionErrorDialog: {
    title: 'Ongeldige sessie',
    description:
      'Je sessie is verlopen of er heeft een fout plaats gevonden. Log opnieuw in om door te gaan met je sessie.',
    supportDescription:
      'Indien je deze melding direct weer te zien krijgt nadat je opnieuw bent ingelogd. Neem dan contact op met Afosto support.',
    actions: {
      loginAgain: 'Opnieuw inloggen',
    },
  },
};

export default translations;
